import { Injectable } from '@angular/core';
import {catchError, Observable, retry} from "rxjs";
import {CoOpMemberModel} from "../models-otc/co-op-member-model";
import { HttpClient } from "@angular/common/http";
import {MatSnackBar} from "@angular/material/snack-bar";
import {HelperService} from "../../helper.service";
import {BaseService} from "../../services/base.service";

@Injectable({
    providedIn: 'root'
})
export class CoOpMemberService extends BaseService {

    constructor(
        private httpClient: HttpClient,
        public snackBar: MatSnackBar,
        public helper: HelperService,
    ) {
        super();
    }

    /// GET ///
    getCoOpMemberList(soldToTenantId: number, payerTenantId: number): Observable<CoOpMemberModel[]> {
        return this.httpClient.get<CoOpMemberModel[]>(this.OTC_BASE_URL + `members?soldToTenantId=${soldToTenantId}&payerTenantId=${payerTenantId}`)
            .pipe(
                retry(1),
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open('Error Retrieving Co-Op Member List','close', {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }


    /// POST ///
    postNewCoOpNumber(soldToTenantId: number, payerTenantId: number, memberNumber: string): Observable<CoOpMemberModel> {
        const coOpMemberBody = {
            soldToTenantId: soldToTenantId,
            payerTenantId: payerTenantId,
            memberNumber: memberNumber
        }

        return this.httpClient.post<CoOpMemberModel>(this.OTC_BASE_URL + 'members',coOpMemberBody)
            .pipe(
                retry(1),
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open('Error Creating New Co-Op Member','close', {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }

}
